import Button from '@mui/material/Button';
import TableCell from '@mui/material/TableCell';

// ----------------------------------------------------------------------

type Props = {
  rowId: string;
  headerIndex: number;
  handleResolve?: (id: string) => void | Promise<void>;
  isResolving?: boolean;
};

export function RowCellKnowledgeGapActions({
  rowId,
  headerIndex,
  handleResolve,
  isResolving,
}: Props) {
  return (
    <TableCell align="right" key={headerIndex}>
      <Button
        size="small"
        variant="outlined"
        disabled={isResolving}
        onClick={() => handleResolve?.(rowId)}
      >
        Resolve
      </Button>
    </TableCell>
  );
}
